// ═══════════════════════════════════════════════════════════════════════════
// WRITTN - Analytics Event Types
// ═══════════════════════════════════════════════════════════════════════════
// Centralized event type definitions for comprehensive tracking
// ═══════════════════════════════════════════════════════════════════════════

export const EVENT_TYPES = {
    // Session Events
    SESSION_START: 'session_start',
    SESSION_END: 'session_end',

    // Verse Interaction Events
    VERSE_VIEWED: 'verse_viewed',
    VERSE_SCROLLED_EARLY: 'verse_scrolled_early',
    VERSE_FAVORITED: 'verse_favorited',
    VERSE_UNFAVORITED: 'verse_unfavorited',
    VERSE_SHARED: 'verse_shared',

    // Meditation Events
    MEDITATION_STARTED: 'meditation_started',
    MEDITATION_ENDED: 'meditation_ended',

    // Passage Events
    PASSAGE_OPENED: 'passage_opened',

    // Journal Events
    JOURNAL_CREATED: 'journal_created',
    JOURNAL_EDITED: 'journal_edited',
    JOURNAL_DELETED: 'journal_deleted',
    JOURNAL_VIEWED: 'journal_viewed',

    // Navigation Events
    DIVE_DEEPER_OPENED: 'dive_deeper_opened',
    EXPLORE_OPENED: 'explore_opened',
    FAVORITES_OPENED: 'favorites_opened',
    SETTINGS_OPENED: 'settings_opened',
    JOURNAL_LIST_OPENED: 'journal_list_opened',

    // Settings Events
    THEME_CHANGED: 'theme_changed',
    SOAK_TIME_CHANGED: 'soak_time_changed',
    ACTION_BAR_LAYOUT_CHANGED: 'action_bar_layout_changed',

    // Generic Events
    BUTTON_TAPPED: 'button_tapped',
    SCROLL: 'scroll',
    ERROR: 'error',
};

// Event schema definitions for validation
export const EVENT_SCHEMAS = {
    [EVENT_TYPES.SESSION_START]: {
        required: ['sessionId', 'platform', 'device', 'appVersion'],
        optional: ['userId', 'referrer']
    },
    [EVENT_TYPES.SESSION_END]: {
        required: ['sessionId', 'duration'],
        optional: ['versesViewed', 'versesFavorited', 'meditationTime']
    },
    [EVENT_TYPES.VERSE_VIEWED]: {
        required: ['verseRef', 'duration'],
        optional: ['source', 'category', 'theme']
    },
    [EVENT_TYPES.VERSE_SCROLLED_EARLY]: {
        required: ['verseRef', 'timeOnScreen', 'soakRequired'],
        optional: []
    },
    [EVENT_TYPES.VERSE_FAVORITED]: {
        required: ['verseRef'],
        optional: ['category', 'theme']
    },
    [EVENT_TYPES.VERSE_SHARED]: {
        required: ['verseRef', 'shareType'],
        optional: ['success']
    },
    [EVENT_TYPES.MEDITATION_STARTED]: {
        required: ['verseRef'],
        optional: []
    },
    [EVENT_TYPES.MEDITATION_ENDED]: {
        required: ['verseRef', 'duration'],
        optional: []
    },
    [EVENT_TYPES.JOURNAL_CREATED]: {
        required: ['verseRef', 'wordCount'],
        optional: ['entryId']
    },
    [EVENT_TYPES.THEME_CHANGED]: {
        required: ['from', 'to'],
        optional: []
    },
    [EVENT_TYPES.BUTTON_TAPPED]: {
        required: ['buttonId'],
        optional: ['context', 'verseRef']
    },
};

// Metrics for aggregation
export const AGGREGATABLE_METRICS = {
    // Counts
    sessions: ['SESSION_START'],
    verses_viewed: ['VERSE_VIEWED'],
    verses_favorited: ['VERSE_FAVORITED'],
    verses_unfavorited: ['VERSE_UNFAVORITED'],
    verses_shared: ['VERSE_SHARED'],
    meditations: ['MEDITATION_STARTED'],
    journals_created: ['JOURNAL_CREATED'],
    early_scrolls: ['VERSE_SCROLLED_EARLY'],

    // Durations (sum)
    total_session_time: { event: 'SESSION_END', field: 'duration' },
    total_verse_time: { event: 'VERSE_VIEWED', field: 'duration' },
    total_meditation_time: { event: 'MEDITATION_ENDED', field: 'duration' },
};

// Time period helpers
export const TIME_PERIODS = {
    TODAY: 'today',
    YESTERDAY: 'yesterday',
    THIS_WEEK: 'this_week',
    LAST_WEEK: 'last_week',
    THIS_MONTH: 'this_month',
    LAST_MONTH: 'last_month',
    LAST_90_DAYS: 'last_90_days',
    PREVIOUS_90_DAYS: 'previous_90_days',
    THIS_YEAR: 'this_year',
    LAST_YEAR: 'last_year',
};

export default {
    EVENT_TYPES,
    EVENT_SCHEMAS,
    AGGREGATABLE_METRICS,
    TIME_PERIODS
};
